<template>
  <div class="col-12 animated fadeIn">
    <questionCard
      ref="questionCard"
      :title="$lang.azmoonLang.question_list"
      :url="questionUrl"
      @addItem="createQA"
      @edit_item="editQuestion"
      @cloneItem="cloneItem"
      :show_add="true"
      :componentName="`search-question`"
    />
    <b-modal no-close-on-backdrop title v-model="isClone" hide-footer size="lg">
      <template v-slot:modal-header>
        {{ $lang.azmoonLang.loading_clone_question }}
        {{ question_item && question_item.id }}
      </template>
      <cloneQuestuion
        v-if="question_item"
        :isClone="isClone"
        :question_item="question_item"
        @closeModal="closeCloneModal"
        @getDataSeach="getDataSeach"
      />
    </b-modal>
  </div>
</template>
<script>
import questionCard from "@/components/azmoon/question/questionCard";
import cloneQuestuion from "./cloneQuestuion";
export default {
  name: "search-question",
  components: {
    questionCard,
    cloneQuestuion,
  },
  data() {
    return {
      questionUrl: this.$config.api_url + this.$config.azmoon.question,
      show_modal: false,
      isClone: false,
      question_item: {},
    };
  },
  methods: {
    cloneItem({ question_info }) {
      this.isClone = true;
      this.question_item = question_info;
    },

    editQuestion(item) {
      this.$router.push({
        name: "edit_structureQuestion",
        params: {
          id: item.question_info.id,
        },
      });
    },
    openModal() {
      this.show_modal = true;
    },
    closeModal() {
      this.show_modal = false;
    },
    closeCloneModal() {
      this.isClone = false;
    },
    getDataSeach() {
      this.isClone = false;
      this.$refs.questionCard.fillTable();
    },
    createQA() {
      this.$router.push({
        name: "structureQuestion",
      });
    },
    remove_content(item) {
      return this.$httpService
        .delete(this.contentPersonUrl + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
  },
};
</script>
